// Desktop-only design tokens (keep in sync with design mock)
export const desktopTheme = {
  bg: '#000000',
  panel: '#0B0B0B',
  // Cards in the mock look like a solid dark gray (not transparent)
  surface: '#2A2A2A',
  surfaceHover: '#303030',

  borderSubtle: 'rgba(255, 255, 255, 0.06)',
  borderStrong: 'rgba(255, 255, 255, 0.10)',

  textPrimary: '#FFFFFF',
  textSecondary: 'rgba(255, 255, 255, 0.55)',
  textTertiary: 'rgba(255, 255, 255, 0.40)',

  accent: '#FF2300',
  accentHover: '#FF3A1A',

  shadowCard: '0 10px 30px rgba(0, 0, 0, 0.55)',
  shadowMenu: '0 10px 30px rgba(0, 0, 0, 0.65)',
};


